<template>
  <div
    class="post-list divide-y divide-lightest-gray"
    v-if="'success' == status"
  >
    <ListItem v-for="post in posts" :key="post.id" :post="post" />
  </div>

  <PostListAnimation v-else />
</template>

<script>
import ListItem from "@/templates/post-list/Item.vue";
import PostListAnimation from "@/components/animation/PostListAnimation.vue";

export default {
  props: {
    posts: Array,
    status: String,
  },
  components: { ListItem, PostListAnimation },
};
</script>

<style scoped>
.thumbnail-bg {
  flex: 0 0 180px;
  height: 120px;
}
.post-content {
  flex-basis: calc(100% - 180px);
}

@media (max-width: 768px) {
  .thumbnail-bg {
    flex-basis: 120px;
  }

  .post-content {
    flex-basis: calc(100% - 120px);
  }
}
</style>
